// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to your CSS file or within a \\3c style> tag in your component file */
.tool-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 5px 5px 0px 0px #879FD2;
    transition-timing-function: cubic-bezier(0.795, 0, 0.165, 1);
}

.tool-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}


.arrowIcon {
    font-size: 20px;
    position: absolute;
    margin: 0 0 0 340px;
}

.badge-tools {
  position: relative;
  transition: all 0.3s ease-in-out;
  border: 2px solid #ffffff4d;
  overflow: hidden;
}

.badge-tools:hover {
  transform: scale(1.05);
}

.badge-tools:hover .icon {
  transform: translate(4px);
}

.badge-tools:hover::before {
  animation: shine 1.5s ease-out infinite;
}

.badge-tools::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100%;
  background-image: linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0) 70%);
  top: 0;
  left: -100px;
  opacity: 0.6;
}

@keyframes shine {
  0% {
    left: -100px;
  }

  60% {
    left: 100%;
  }

  to {
    left: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Tools/Tools.css"],"names":[],"mappings":"AAAA,gFAA6E;AAC7E;IACI,qDAAqD;IACrD,mCAAmC;IACnC,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;IAC3B,sDAAsD;AAC1D;;;AAGA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,2HAA2H;EAC3H,MAAM;EACN,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Add this to your CSS file or within a <style> tag in your component file */\n.tool-card {\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    box-shadow: 5px 5px 0px 0px #879FD2;\n    transition-timing-function: cubic-bezier(0.795, 0, 0.165, 1);\n}\n\n.tool-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;\n}\n\n\n.arrowIcon {\n    font-size: 20px;\n    position: absolute;\n    margin: 0 0 0 340px;\n}\n\n.badge-tools {\n  position: relative;\n  transition: all 0.3s ease-in-out;\n  border: 2px solid #ffffff4d;\n  overflow: hidden;\n}\n\n.badge-tools:hover {\n  transform: scale(1.05);\n}\n\n.badge-tools:hover .icon {\n  transform: translate(4px);\n}\n\n.badge-tools:hover::before {\n  animation: shine 1.5s ease-out infinite;\n}\n\n.badge-tools::before {\n  content: \"\";\n  position: absolute;\n  width: 100px;\n  height: 100%;\n  background-image: linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0) 70%);\n  top: 0;\n  left: -100px;\n  opacity: 0.6;\n}\n\n@keyframes shine {\n  0% {\n    left: -100px;\n  }\n\n  60% {\n    left: 100%;\n  }\n\n  to {\n    left: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
